import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
export function markUnread(discussion) {
  return discussion.save({
    unread: true
  }).then(() => {
    if (app.current.matches(DiscussionPage)) {
      app.current.get('stream')?.update();
    }
    m.redraw();
  });
}
export default function extendDiscussionControls() {
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (!discussion.canMarkUnread() || discussion.isUnread()) return;
    items.add('fof-mark-unread', m(Button, {
      icon: "fas fa-envelope",
      onclick: () => markUnread(discussion)
    }, app.translator.trans('fof-mark-unread.forum.discussion_controls.mark_unread_button')), 30);
  });
}
flarum.reg.add('fof-mark-unread', 'forum/extenders/extendDiscussionControls', extendDiscussionControls);